import { observer } from "mobx-react-lite";
import React, { useCallback } from "react";
import { Box, BoxProps, Flex, Spacer, Text } from "@chakra-ui/react";
import { themeStore } from "@/stores/theme";

interface MenuOptionProps extends BoxProps {
  text?: string;
  hideMenu?: () => void;
  action?: React.ReactNode;
}
const MenuOption: React.FC<MenuOptionProps> = ({
  text,
  hideMenu,
  onClick,
  children,
  action,
  ...restProps
}) => {
  const { captionColor, selectBgColor } = themeStore.styles;

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      hideMenu?.();
      onClick?.(e);
    },
    [hideMenu, onClick],
  );

  return (
    <Box
      w="100%"
      h="32px"
      px="24px"
      userSelect="none"
      as="button"
      textAlign="left"
      _hover={{
        bg: selectBgColor,
      }}
      onClick={handleClick}
      {...restProps}
    >
      {children ?? (
        <Flex alignItems="center" gap={2}>
          <Text color={captionColor}>{text}</Text>
          <Spacer />
          {action ?? null}
        </Flex>
      )}
    </Box>
  );
};
export default observer(MenuOption);
